export default __webpack_public_path__ + "static/media/Victory_Banner.eb1ca196.png";